"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
  _react = _interopRequireDefault(require("react")),
  _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha")),
  Captcha = function Captcha(a) {
    var b = a.field,
      c = a.validationMessage,
      d = a.error,
      e = a.sitekey,
      f = a.styledComponents,
      g = a.setTouched,
      h = a.unsetError,
      i = a.touched,
      j = a.hideField,
      k = (0, _objectWithoutProperties2["default"])(a, ["field", "validationMessage", "error", "sitekey", "styledComponents", "setTouched", "unsetError", "touched", "hideField"]),
      l = b.id,
      m = b.captchaTheme,
      n = b.formId,
      o = b.captchaLanguage,
      p = b.width,
      q = b.cssClass,
      r = b.description,
      s = b.descriptionPlacement,
      t = (f || !1).Box,
      u = void 0 === t ? "div" : t;
    return e ? _react["default"].createElement(u, {
      width: p,
      className: c && i || d ? "form-field captcha error ".concat(q) : "form-field captcha ".concat(q),
      style: {
        display: j ? "none" : void 0
      }
    }, "above" === s && r && _react["default"].createElement("div", {
      className: "description",
      dangerouslySetInnerHTML: {
        __html: r
      }
    }), _react["default"].createElement(_reactGoogleRecaptcha["default"], {
      sitekey: e,
      theme: m,
      hl: o,
      onChange: function onChange() {
        g(l), h(l);
      }
    }), "above" !== s && r && _react["default"].createElement("div", {
      className: "description",
      dangerouslySetInnerHTML: {
        __html: r
      }
    }), (c && i || d) && _react["default"].createElement("span", {
      className: "error-message",
      id: "error_".concat(n, "_").concat(l)
    }, c || d)) : null;
  },
  _default = Captcha;
exports["default"] = _default;